import ListingHeader from "../../../components/listingHeader/listingHeader";
import styles from "./spotlightCarousel.module.scss";
import { Carousel, ContentWrapper } from "@crunchyroll/cx-web-components";
import { LeftArrowSVG, RightArrowSVG } from "../../../svg";
import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";
import { useStoryblokGlobalSettings } from "../../../hooks/useStoryblokGlobalSettings";
import { ThemeContext } from "../../../context/themecontext";
import { useContext } from "react";
import { useStoryblokSpotlightCarouselWidget } from "../../../hooks/useStoryblokSpotlightCarouselWidget";
import { FormattedMessage } from "react-intl";

function SpotlightCarousel({ blok }) {
  const theme = useContext(ThemeContext);
  const [articles, isLoading] = useStoryblokSpotlightCarouselWidget();
  const globalSettings = useStoryblokGlobalSettings();
  const backgroundImage =
    theme.value === "dark"
      ? globalSettings.spotlight_background_image
      : globalSettings.spotlight_background_image_light;

  if (!isLoading && articles.length === 0) {
    return null;
  }

  return (
    <div
      className={`${styles.root} ${
        blok.margin_top ? styles.marginTopDefault : ""
      } ${blok.margin_bottom ? styles.marginBottomDefault : ""}`}
    >
      <ListingHeader
        underlineColor={
          blok.header_underline_color
            ? blok.header_underline_color
            : "border-color-crscooter"
        }
        withClass={styles.listingHeader}
      >
        <h2>
          <FormattedMessage id="component.spotlight_carousel.headline" />
        </h2>
      </ListingHeader>
      <Carousel className={styles.carousel}>
        <Carousel.CarouselContext.Consumer>
          {({
            isHovered,
            isNearTheEnd,
            offset,
            scrollStep,
            setCSSVariable,
            setIsAutoplayTick,
            setScrollPosition,
          }) => (
            <Carousel.Autoplay
              autoplayDuration={8000}
              isAutoplayPaused={false || isHovered}
              isNearTheEnd={isNearTheEnd}
              offset={offset}
              scrollStep={scrollStep}
              setCSSVariable={setCSSVariable}
              setIsAutoplayTick={setIsAutoplayTick}
              setScrollPosition={setScrollPosition}
            />
          )}
        </Carousel.CarouselContext.Consumer>
        <Carousel.Arrow
          className={`${styles.arrow} ${styles.leftArrow}`}
          direction="start"
        >
          <LeftArrowSVG />
        </Carousel.Arrow>
        <Carousel.Arrow
          className={`${styles.arrow} ${styles.rightArrow}`}
          direction="end"
        >
          <RightArrowSVG />
        </Carousel.Arrow>
        {articles.length ? (
          <Carousel.Scroller>
            {articles.map((a) => (
              <ArticleListingCard
                withClass={styles.card}
                key={a._uid}
                layout="spotlight"
                backgroundImage={backgroundImage}
                imageWidth={564}
                imageHeight={308}
                slug={a.slug}
                thumbnail={a.content.thumbnail}
                authors={a.content.authors}
                title={a.content.headline}
                date={a.content.article_date}
                article_category={a.content.category}
                article_type={a.content.article_type}
                comment_count={5}
                enable_comments={a.content.has_comments}
                enable_social_sharing={a.content.has_social_sharing}
                use_legacy_thumbnail_background={
                  a.content.legacy_thumbnail_background
                }
              />
            ))}
          </Carousel.Scroller>
        ) : null}

        <ContentWrapper className={styles.tabs}>
          <Carousel.Tabs pagesTitles={["", "", "", "", "", ""]} />
        </ContentWrapper>
      </Carousel>
    </div>
  );
}

export default SpotlightCarousel;
